import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon, SendIcon, CameraIcon, CheckCircle2Icon, Wand2Icon } from 'lucide-react';
export function SellFlow() {
  const [query, setQuery] = useState('');
  const [step, setStep] = useState(0);
  const [chatHistory, setChatHistory] = useState<{
    role: 'user' | 'ai';
    content: string | React.ReactNode;
  }[]>([{
    role: 'ai',
    content: 'Hi! What would you like to sell today? Just tell me what it is.'
  }]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!query.trim()) return;
    const userMsg = query;
    setQuery('');
    setChatHistory(prev => [...prev, {
      role: 'user',
      content: userMsg
    }]);
    if (step === 0) {
      setTimeout(() => {
        setChatHistory(prev => [...prev, {
          role: 'ai',
          content: "Great, a 2018 Prado. I've set up the basic category. Could you upload a few photos? I can help make them look professional."
        }]);
        setStep(1);
      }, 1000);
    }
  };
  const handlePhotoUpload = () => {
    setChatHistory(prev => [...prev, {
      role: 'user',
      content: <div className="flex gap-2" data-id="element-6011" data-mp="21r8ybtrt4cy9">
            <div className="w-20 h-20 bg-slate-200 rounded-lg overflow-hidden" data-id="element-6012" data-mp="21q7cqvd6082a">
              <img src="https://images.unsplash.com/photo-1590362891991-f776e747a588?auto=format&fit=crop&q=80&w=200" alt="Car" className="w-full h-full object-cover" data-id="element-6013" data-mp="1440ahs4c2rt3" />
            </div>
            <div className="w-20 h-20 bg-slate-200 rounded-lg overflow-hidden" data-id="element-6014" data-mp="1dzbqedrha52f">
              <img src="https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?auto=format&fit=crop&q=80&w=200" alt="Car" className="w-full h-full object-cover" data-id="element-6015" data-mp="1ity0mdltprkx" />
            </div>
          </div>
    }]);
    setTimeout(() => {
      setChatHistory(prev => [...prev, {
        role: 'ai',
        content: <div className="space-y-4" data-id="element-6016" data-mp="e7g8tvitptky">
              <p data-id="element-6017" data-mp="rzmfmr036o7q">
                Thanks! I've analyzed the photos and drafted your listing. How
                does this look?
              </p>
              <div className="bg-white rounded-xl p-4 border border-slate-200 shadow-sm text-slate-800" data-id="element-6018" data-mp="n3nv5ehvpqcl">
                <h4 className="font-bold text-lg mb-2" data-id="element-6019" data-mp="3vj7kw3jccqmw">
                  Toyota Land Cruiser Prado GXR 2018
                </h4>
                <p className="text-sm text-slate-600 mb-3" data-id="element-6020" data-mp="9apmwrkc83rm">
                  Excellent condition, original paint. Based on market data, I
                  suggest pricing it at AED 82,000.
                </p>
                <div className="grid grid-cols-2 gap-2 text-sm" data-id="element-6021" data-mp="1kojvkngts8xb">
                  <div className="bg-slate-50 p-2 rounded" data-id="element-6022" data-mp="1fq8noia3c8hq">
                    Price: AED 82,000
                  </div>
                  <div className="bg-slate-50 p-2 rounded" data-id="element-6023" data-mp="2xndd35bmhfyn">Specs: GCC</div>
                </div>
              </div>
              <div className="flex flex-col gap-2" data-id="element-6024" data-mp="32o12xno47qra">
                <button className="w-full py-2 bg-gradient-to-r from-primary-indigo to-ai-purple text-white rounded-lg font-medium flex items-center justify-center gap-2" data-id="element-6025" data-mp="32klqytpqmxu3">
                  <Wand2Icon className="w-4 h-4" data-id="element-6026" data-mp="2tmjt2n1awlb1" />
                  Make photos look professional (AI)
                </button>
                <button className="w-full py-2 bg-slate-100 text-slate-700 rounded-lg font-medium hover:bg-slate-200 transition-colors" data-id="element-6027" data-mp="3ldg4dj7pqhw7">
                  Publish Listing
                </button>
              </div>
            </div>
      }]);
      setStep(2);
    }, 1500);
  };
  return <div className="flex-1 flex flex-col h-[calc(100vh-60px)] lg:h-screen bg-slate-50" data-id="element-6028" data-mp="45cetqe836zh">
      <div className="p-4 bg-white border-b border-slate-200 text-center sticky top-0 z-10" data-id="element-6029" data-mp="43hofwk6mmo0">
        <h1 className="font-display font-bold text-xl text-dark-navy" data-id="element-6030" data-mp="8xvq2gpftq14">
          Tell Talab what you want to sell
        </h1>
      </div>

      <div className="flex-1 overflow-y-auto p-4 lg:p-8" data-id="element-6031" data-mp="2bg9m7zr9wfi5">
        <div className="max-w-2xl mx-auto w-full space-y-6 pb-20" data-id="element-6032" data-mp="2bivszx6caqzb">
          {chatHistory.map((msg, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} className={`flex ${msg.role === 'user' ? 'justify-end' : 'justify-start'}`} data-id="element-6033" data-mp="22fuo1zt7n5x8" data-mpi={idx}>
              {msg.role === 'ai' && <div className="w-8 h-8 rounded-full bg-gradient-to-br from-primary-indigo to-ai-purple flex items-center justify-center mr-3 flex-shrink-0 shadow-sm" data-id="element-6034" data-mp="2qbp8vjpix94i">
                  <SparklesIcon className="w-4 h-4 text-white" data-id="element-6035" data-mp="3iuw9682scyfx" />
                </div>}
              <div className={`max-w-[85%] rounded-2xl px-5 py-3.5 shadow-sm ${msg.role === 'user' ? 'bg-primary-indigo text-white rounded-tr-none' : 'bg-white border border-slate-200 text-slate-700 rounded-tl-none'}`} data-id="element-6036" data-mp="3e2mb24rios2k">
                {msg.content}
              </div>
            </motion.div>)}
        </div>
      </div>

      <div className="bg-white border-t border-slate-200 p-4 sticky bottom-0 z-10" data-id="element-6037" data-mp="38nvo6tx9wtc">
        <div className="max-w-2xl mx-auto w-full" data-id="element-6038" data-mp="880iwsoph5wg">
          {step === 1 ? <div className="flex gap-3" data-id="element-6039" data-mp="85whqii6ykzv">
              <button onClick={handlePhotoUpload} className="flex-1 py-4 bg-slate-100 border-2 border-dashed border-slate-300 rounded-xl text-slate-600 font-medium flex items-center justify-center gap-2 hover:bg-slate-50 hover:border-primary-indigo transition-all" data-id="element-6040" data-mp="d6kb3atw7dx9">
                <CameraIcon className="w-5 h-5" data-id="element-6041" data-mp="qzjnh3ydos0l" />
                Upload Photos
              </button>
            </div> : step === 0 ? <form onSubmit={handleSubmit} className="relative ai-glow" data-id="element-6042" data-mp="vv8olbq1qgz0">
              <input type="text" value={query} onChange={e => setQuery(e.target.value)} placeholder="E.g., I want to sell my 2018 Prado" className="w-full px-6 py-4 pr-14 bg-white border-2 border-slate-200 rounded-2xl text-base focus:outline-none focus:border-primary-indigo focus:ring-4 focus:ring-primary-indigo/10 transition-all" data-id="element-6043" data-mp="2s19bm91j79ub" />
              <button type="submit" disabled={!query.trim()} className="absolute right-2 top-1/2 -translate-y-1/2 p-2.5 bg-gradient-to-r from-primary-indigo to-ai-purple text-white rounded-xl hover:shadow-lg transition-all disabled:opacity-50" data-id="element-6044" data-mp="3bqjq5jpjjoqu">
                <SendIcon className="w-5 h-5" data-id="element-6045" data-mp="1qbdyoe8ruhvn" />
              </button>
            </form> : null}
        </div>
      </div>
    </div>;
}